import LoginWithImageTwoContainer from "../../Componant/Authentication/LoginWithImageTwo";
import { Container, Row } from "reactstrap";

const LoginWithImageTwo = () => {
  return (
    <Container fluid>
      <Row>
        <LoginWithImageTwoContainer />
      </Row>
    </Container>
  );
};

export default LoginWithImageTwo;
